<template>
  <validation-observer ref="loginForm" >
    <b-form class="auth-login-form mt-2" @submit.prevent="login">
      <!-- email -->
      <b-form-group label-for="email" label="Email">
        <validation-provider
          #default="{ errors }"
          name="Email"
          rules="required|email"
        >
          <b-form-input
            id="email"
            v-model="userEmail"
            name="login-email"
            :state="errors.length > 0 ? false : null"
            autocomplete="on"
            autofocus
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- password -->
      <b-form-group>
        <div class="d-flex justify-content-between">
          <label for="password">Password</label>
          <b-link class="text-muted" :to="{ name: 'auth-user-forgot-password' }">
            <small>Forgot Password?</small>
          </b-link>
        </div>
        <validation-provider
          #default="{ errors }"
          name="Password"
          rules="required"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              id="password"
              v-model="password"
              :type="passwordFieldType"
              class="form-control-merge"
              :state="errors.length > 0 ? false : null"
              name="login-password"
              autocomplete="on"
            />

            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="passwordToggleIcon"
                @click="togglePasswordVisibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- checkbox -->
      <b-form-group>
        <b-form-checkbox id="remember-me" v-model="status" name="checkbox-1">
          Remember Me
        </b-form-checkbox>
      </b-form-group>

      <!-- submit button -->
      <b-button class="gradient-btn py-2" type="submit" block >
        Sign in
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: false,
      loading: false,
      // validation rules
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  created() {
    if (localStorage.getItem("login")) {
      const item = JSON.parse(localStorage.getItem("login"));
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem("login");
      } else {
        this.userEmail = item.value.userEmail;
        this.password = item.value.password;
        this.status = true;
      }
    }
  },
  methods: {
    setWithExpiry(key, value, ttl) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
    },
    login() {
      this.$refs.loginForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          if (this.status) {
            this.setWithExpiry(
              "login",
              {
                userEmail: this.userEmail,
                password: this.password,
              },
              259200000
            );
          }
          try {
            const { data } = await this.$http.post("auth/user/login", {
              email: this.userEmail.toLowerCase(),
              password: this.password,
            });
            this.$http.defaults.headers.common["Authorization"] =
              await `${data.type} ${data.token}`;
            await localStorage.setItem(
              "userData",
              JSON.stringify({
                ...data.user,
                email_verified: data.email_verified,
                type: data.abilities[0].includes("admin") ? "admin" : "user",
              })
            );
            await this.$store.dispatch("auth/setUserData", {
              ...data.user,
              email_verified: data.email_verified,
              type: data.abilities[0].includes("admin") ? "admin" : "user",
            });
            await localStorage.setItem(
              "token",
              JSON.stringify({ val: data.token, type: data.type })
            );
            if (data.email_verified) {
              let wantToRegister = localStorage.getItem("wantToRegister");
              this.$router.push(
                wantToRegister
                  ? { name: "show-competition", params: { id: wantToRegister } }
                  : { name: "user-dashboard" }
              );
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Welcome ${
                    data.user.first_name + " " + data.user.last_name
                  }`,
                  icon: "CoffeeIcon",
                  variant: "success",
                  text: `You have successfully logged in as ${
                    data.user.first_name + " " + data.user.last_name
                  }. Now you can start to explore!`,
                },
              });
            } else {
              this.$router.push({ name: "auth-user-email-verify" });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Welcome ${
                    data.user.first_name + " " + data.user.last_name
                  }`,
                  icon: "CoffeeIcon",
                  variant: "warning",
                  text: `Please, verify your email !`,
                },
              });
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
